<template>  
  <div class="main readWatchtitle">
    <div class="readWatchText">
      电表读数
    </div>
    <div class="datePicker" @click="dialogFormVisible = true">
      时间段：<span>{{dateRange[0]}}</span>到<span>{{dateRange[1]}}</span>
    </div>
    <div class="pageNum">
      显示条数：
      <!--每页数量选择器-->
      <el-select size="mini" v-model="numValue" @change="chooseNumValue">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="exportButton" @click="exportEmeterByDayList">
      <el-button size="small">导出excel</el-button>
    </div>

    <!--日期范围选择器-->
    <el-dialog title="日期范围选择" :visible.sync="dialogFormVisible">
      <div class="block">
        <span class="demonstration">日期范围：</span>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          align="right"
          value-format="yyyy-MM-dd"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions2">
        </el-date-picker>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="chooseDate">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  import * as date from "../../../../../static/js/date.js";
  import { deviceApi } from "../../../../../static/js/api.js"
  import { showToast } from "../../../../../static/js/utility/utility.js"
  export default {
    name: 'ReadWatchTitle',
    data() {
      return {
        'dateRange':[],
        'dialogFormVisible':false,
        pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        options: [{
          value: 10,
          label: '10'
        }, {
          value: 100,
          label: '100'
        }, {
          value: 200,
          label: '200'
        }],
        numValue: 10,
      }
    },
    mounted() {
      
    },
    created() {
      // 初始化时间范围
      this.initDateRange();
    },
    methods: {
      // 选择时间范围
      chooseDate() {
        this.dialogFormVisible = false;
        this.$store.commit('saveBuildingWatchDateRange',this.dateRange);
      },
      // 选择每页数量
      chooseNumValue(data) {
        this.$store.commit('saveBuildingWatchPerPage',data);
      },
      // 初始化日期选择范围
      initDateRange() {
        this.dateRange[0] = date.getLastMonthDate();
        this.dateRange[1] = date.getNowFormatDate();
      },
      //导出电表读数列表
      async exportEmeterByDayList(){
        let that = this;
        const dataObj = {
          startTime:this.dateRange[0],
          endTime:this.dateRange[1],
        }
        const res = await deviceApi.expEmeterByDayList(dataObj)
        if(res.meta.code == '200'){
          window.open(res.data.fileUrl)
        }else{
          showToast(res.meta.message)
        }
      },
    },
    props: []
  }
</script>

<style lang="scss" scoped>
.readWatchtitle{
  color: #999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  font-size: 14px;
  margin-top: 10px;
  .el-select{
    width: 70px;
  }
  .datePicker{
    span{ color: #5c75f3; }
  }
  .readWatchText {
    font-size: 1em;
    font-weight: bold;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Page/CEnergyManage/BuildingInfo/ReadWatchTitle.vue